import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

/**
 * M11 finding 18: says, where the text is typed, that an AI helper sends it
 * to an AI provider (the same disclosure AI search makes in DashboardSearch).
 * The edge functions mask contact details, addresses and long numbers before
 * the provider sees the text; this tells people not to rely on that.
 */
export function AiProviderNotice({ children, className }: { children?: ReactNode; className?: string }) {
  return (
    <p className={cn('text-[11px] text-muted-foreground', className)} data-testid="ai-provider-notice">
      {children ?? "What you type here is sent to an AI provider to suggest services. Don't include names or contact details."}
    </p>
  );
}
